import { memo, useEffect } from 'react'
import { useIsActiveTurn } from '../../../../store'
import { acceptedClipboardFiles, useAttachFiles } from '../hooks/use-attach-files'

/** Catches a file paste anywhere outside the composer and attaches it. */
export const FilePasteHandler = memo(() => {
  const isChatLoading = useIsActiveTurn()
  const attachFiles = useAttachFiles()

  useEffect(() => {
    const onPaste = (e: ClipboardEvent) => {
      if (isChatLoading) {
        return
      }
      const files = acceptedClipboardFiles(e.clipboardData)
      if (!files.length) {
        return
      }
      e.preventDefault()
      void attachFiles(files)
    }
    document.addEventListener('paste', onPaste)
    return () => {
      document.removeEventListener('paste', onPaste)
    }
  }, [isChatLoading, attachFiles])

  return null
})
FilePasteHandler.displayName = 'FilePasteHandler'
